import { render, staticRenderFns } from "./svgCTAB.vue?vue&type=template&id=36b3c85e"
import script from "./svgCTAB.vue?vue&type=script&lang=js"
export * from "./svgCTAB.vue?vue&type=script&lang=js"
import style0 from "./svgCTAB.vue?vue&type=style&index=0&id=36b3c85e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports